import { gql } from '@apollo/client';

export const fragments = {
  all: gql`
    fragment ProcedureDelayReasonData on ProcedureDelayReason {
      id
      procedureId
      patientId
      operationRoomId
      reason
      delayStartedAt
      submittedAt
      skipped
      createdBy
      createdAt
      updatedAt
    }
  `,
};

export const getProcedureDelayReason = gql`
  query GetProcedureDelayReason($procedureId: Long!) {
    procedureDelayReason(procedureId: $procedureId) {
      ...ProcedureDelayReasonData
    }
  }
  ${fragments.all}
`;

export const isDelayReasonRequired = gql`
  query isDelayReasonRequired($procedureId: Long!, $operationRoomId: Long!) {
    isDelayReasonRequired(procedureId: $procedureId, operationRoomId: $operationRoomId) {
      required
      delayStartedAt
      elapsedSeconds
      gracePeriodMinutes
      physician
      patientName
    }
  }
`;

export const submitDelayReason = gql`
  mutation SubmitDelayReason(
    $procedureId: Long
    $patientId: Long
    $operationRoomId: Long
    $reason: String!
    $delayStartedAt: String!
    $createdBy: Long
  ) {
    submitDelayReason(
      procedureId: $procedureId
      patientId: $patientId
      operationRoomId: $operationRoomId
      reason: $reason
      delayStartedAt: $delayStartedAt
      createdBy: $createdBy
    ) {
      id
      reason
      submittedAt
    }
  }
`;

export const skipDelayReason = gql`
  mutation SkipDelayReason(
    $procedureId: Long
    $patientId: Long
    $operationRoomId: Long
    $delayStartedAt: String!
    $createdBy: Long
  ) {
    skipDelayReason(
      procedureId: $procedureId
      patientId: $patientId
      operationRoomId: $operationRoomId
      delayStartedAt: $delayStartedAt
      createdBy: $createdBy
    ) {
      id
      skipped
    }
  }
`;

export const updateDelayReason = gql`
  mutation UpdateDelayReason($id: Long!, $reason: String!) {
    updateDelayReason(id: $id, reason: $reason) {
      id
      reason
      submittedAt
    }
  }
`;

export const proceduresForOperationRoomDay = gql`
  query proceduresForOperationRoomDay($date: Date!, $operationRoomId: Long!, $isCanceled: Boolean) {
    procedures(date: $date, operationRoomId: $operationRoomId, isCanceled: $isCanceled) {
      id
      startTime
    }
  }
`;
